module.exports = __webpack_public_path__ + "img/party_open.6fb7b0f4.png";